import BaseOption from "%/dynamic-component-editor/classes/base-option";
import { inspectorTools } from "%/dynamic-component-editor/inspector/inspector-tool-map";

// Container "scale" anchor. Stored `{ anchor, elementWidth }` (px): anchor = the
// breakpoint preview width captured on enable; elementWidth = the element's rendered
// width at that anchor viewport, builder-measured at capture (can't be re-derived at
// render without resizing), 0 = not measured (legacy). Render zoom (appearance-mixin):
// (viewport - (anchor - elementWidth)) / elementWidth. "unset" = off. Mixin-resolved
// (like opacity), NOT an optionToProp — the object never reaches a VCL scalar prop.
export default class ScaleWidthAnchor extends BaseOption {
  static userInterfaceComponent = {
    label: "Scale",
    component: inspectorTools.SCALE_CONTROL,
  };

  static defaultValue = "unset";

  static convertConfigValueToCompiledValue(configValue) {
    if (configValue === "unset" || configValue === "" || configValue === null || configValue === undefined) {
      return "unset";
    }
    // Current shape: { anchor, elementWidth }.
    if (typeof configValue === "object") {
      const anchor = parseInt(configValue.anchor, 10);
      if (!Number.isFinite(anchor) || anchor <= 0) {
        return "unset";
      }
      const elementWidth = parseInt(configValue.elementWidth, 10);
      return { anchor, elementWidth: Number.isFinite(elementWidth) && elementWidth > 0 ? elementWidth : 0 };
    }
    // Legacy shape: a bare px anchor (no measured elementWidth).
    const px = parseInt(configValue, 10);
    return Number.isFinite(px) && px > 0 ? { anchor: px, elementWidth: 0 } : "unset";
  }
}
